import React          from 'react';
import currentSession from 'utils/currentSession';
import PublicLayout   from 'containers/Security/PublicLayout';

const Loading = () => (
  <PublicLayout>
    <div>Loading...</div>
  </PublicLayout>
);

interface SecurityGateProps {
  children?: any;
}

class SecurityGate extends React.Component<SecurityGateProps> {
  public state = {
    finished: false,
  };

  public componentDidMount() {
    const token = currentSession.getToken();
    token.then(
      () => {
        this.setState({ finished: true });
      },
      () => {
        this.setState({ finished: true });
      },
    );
  }

  public render() {
    if (!this.state.finished) {
      return <Loading />;
    }
    return this.props.children;
  }
}

export default SecurityGate;
